import { render, staticRenderFns } from "./JoinClinic.vue?vue&type=template&id=76e2ad99&scoped=true"
import script from "./JoinClinic.vue?vue&type=script&lang=js"
export * from "./JoinClinic.vue?vue&type=script&lang=js"
import style0 from "./JoinClinic.vue?vue&type=style&index=0&id=76e2ad99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e2ad99",
  null
  
)

export default component.exports